<template>
  <div class="form-group row">
    <div class="modal-body text-md-left text-sm-center">

      <label>Localização:</label>
      <div class="col-sm-12">
        <div class="form-group input-group" :class="{
          'form-group--error': $v.armazenar.local.$error
        }">
        <input type="text" class="form-control" v-model="$v.armazenar.local.$model">
      </div>
      <div class="error" v-if="!$v.armazenar.local.required">O campo é obrigatório</div>
    </div>

      <label>Motivo:</label>
      <div class="col-sm-12">
        <div class="form-group input-group" :class="{
          'form-group--error': $v.armazenar.motivo.$error
        }">
          <textarea
            class="form-control mb-1"
            v-model.trim="$v.armazenar.motivo.$model"
            rows="5"
            cols="40"
          />
        </div>
        <div class="error" v-if="!$v.armazenar.motivo.required">O campo é obrigatório</div>
      </div>
    </div>

    <div class="col-12" v-if="progress.is" :key="progress.key">
      <hr>
      <div v-for="processo in $store.getters.getDataTableChecked" :key="getKey(processo.data.atributos.numeroProcesso)">
        <span>{{ formatarProtocolo(processo.data.atributos.numeroProcesso) }}</span>
        <span
          v-if="isVisibleTryAgainArmazenar(processo.data.atributos.numeroProcesso)"
          class="badge badge-info link"
          @click="armazenarTramitacao(processo.data.atributos.numeroProcesso)"
        >
          <i class="fa fa-refresh" aria-hidden="true"></i> Armazenar novamente
        </span>
        <progress-bar
          :key="getKey(processo.data.atributos.numeroProcesso)"
          :percentage="getProgress(processo.data.atributos.numeroProcesso)"
          :danger="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :warning="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :success="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :animated="true"
          class="mt-1 mb-3"
        />
      </div>
      <div class="col-12 text-right mb-2" v-if="progress.finished && processos.length !== progress.sucesso">
        <span class="badge badge-info text-left">Alguns protocolos não foram concluidos<br> Tente novamente os protocolos com erro</span>
      </div>
    </div>

    <div class="modal-body text-md-right text-sm-center">
      <button v-if="!progress.is" type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
          closeModalEvent()
        }">Cancelar</button>
      <button v-if="progress.is" type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
        closeModalEvent()
        }">Fechar</button>
      <button v-if="!progress.is" type="button" class="btn btn-outline-primary m-1" @click.prevent="persistirArmazenamento()">Prosseguir</button>
      <button v-if="progress.is" type="button" class="btn btn-outline-dark m-1">Prosseguir</button>
    </div>

  </div>

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VirtusService from '@/services/VirtusService'
import progressBar from '@/components/progressBar/ProgressBar'

import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'

export default {

  name: 'armazenar',

  components: {
    progressBar
  },

  props: {
    closeModalEvent: { required: true, type: Function },
    protocolo: { required: false, type: String },
    atualizarConsulta: { required: true, type: Function }
  },

  data () {
    return {
      armazenar: {
        local: '',
        motivo: '',
        numeroProcesso: '',
        nomeUsuario: '',
        usuarioCriacao: ''

      },

      progress: {
        isArmazenar: false,
        is: false,
        background: false,
        finished: false,
        length: 0,
        sucesso: 0,
        key: false,
        alert: {
          type: 'light',
          texto: 'Armazenando os protocolos:'
        },
        processos: {}
      }
    }
  },

  validations: {
    armazenar: {
      local: {
        required
      },
      motivo: {
        required
      }
    }
  },

  created () {
    this.service = new VirtusService()
  },

  destroyed () {
    this.closeModalEvent()
  },

  methods: {
    async persistirArmazenamento () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.progress = {
        ...this.progress,
        isArmazenar: true,
        is: true,
        background: true,
        key: !this.progress.key,
        alert: {
          type: 'light',
          texto: 'Recebendo/Atribuindo os protocolos:'
        }
      }

      const dataTable = this.$store.getters.getDataTableChecked
      for (const value of dataTable) {
        const numeroProcesso = value.data.processo
        await this.armazenarTramitacao(numeroProcesso)
      }
    },

    async armazenarTramitacao (numeroProcesso) {
      try {
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '50%',
          status: 'warning'
        })
        const dadosSessao = this.$store.getters.getDadosSessao
        this.armazenar.numeroProcesso = numeroProcesso
        this.armazenar.usuarioCriacao = dadosSessao.sessao.login
        this.armazenar.nomeUsuario = dadosSessao.sessao.nomeUsuario

        await this.service.armazenar(this.armazenar)
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '100%',
          status: 'success'
        })
      } catch (error) {
        console.log('Erro', error)
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '100%',
          status: 'danger'
        })
      }
    },

    limparArmazenamento () {
      this.armazenar.local = ''
      this.armazenar.motivo = ''
      this.armazenar.numeroProcesso = ''
      this.armazenar.nomeUsuario = ''
      this.armazenar.usuarioCriacao = ''
    },

    atualizarProgress (numeroProcesso, obj) {
      this.progress.processos[numeroProcesso] = obj
      this.progress.key = !this.progress.key
    },

    getProgress (numeroProcesso) {
      const processo = this.progress.processos[numeroProcesso]
      return processo ? processo.porcentagem || '0%' : '0%'
    },

    getKey (numeroProcesso) {
      return `${numeroProcesso}-${this.getProgress(numeroProcesso)}`
    },

    getStatus (numeroProcesso) {
      const processo = this.progress.processos[numeroProcesso]
      return processo ? processo.status || 'info' : 'info'
    },

    isVisibleTryAgainArmazenar (numeroProcesso) {
      if (!this.progress.isArmazenar) {
        return false
      }
      return this.getStatus(numeroProcesso) === 'danger'
    },

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    }
  }
}

</script>
